export var UCUICMPEventType;
(function (UCUICMPEventType) {
    UCUICMPEventType["ACCEPT_ALL"] = "ACCEPT_ALL";
    UCUICMPEventType["CMP_SHOWN"] = "CMP_SHOWN";
    UCUICMPEventType["DENY_ALL"] = "DENY_ALL";
    UCUICMPEventType["IMPRINT_LINK"] = "IMPRINT_LINK";
    UCUICMPEventType["MORE_INFORMATION_LINK"] = "MORE_INFORMATION_LINK";
    UCUICMPEventType["PRIVACY_POLICY_LINK"] = "PRIVACY_POLICY_LINK";
    UCUICMPEventType["SAVE"] = "SAVE";
})(UCUICMPEventType || (UCUICMPEventType = {}));
export var UCUIView;
(function (UCUIView) {
    UCUIView["FIRST_LAYER"] = "FIRST_LAYER";
    UCUIView["NONE"] = "NONE";
    UCUIView["PRIVACY_BUTTON"] = "PRIVACY_BUTTON";
    UCUIView["SECOND_LAYER"] = "SECOND_LAYER";
})(UCUIView || (UCUIView = {}));
